import styled, { css } from 'styled-components';
import { rem } from 'polished';

const ColorVarianStepBarDivider = styled.span`
    border-radius: ${rem(2)};
    display: block;
    height: ${rem(4)};
    width: 100%;

    ${({ themeMode }) =>
        themeMode === 'lightMode' &&
        css`
            background-color: ${({ theme }) => theme.base.grays.grayLightest};
        `}

    ${({ themeMode }) =>
        themeMode === 'darkMode' &&
        css`
            background-color: ${({ theme }) => theme.base.grays.grayLighter};
        `}
`;

export default ColorVarianStepBarDivider;
